import { ImageList } from "@/components/Elements";
import {
  useGetMessagesMutation,
  useMarkMessageAsReadMutation,
} from "@/services/modules/chat";
import { RootState } from "@/store/reducers";
import { MessageModel } from "@/types/chat";
import { useEffect } from "react";
import { useSelector } from "react-redux";

function Message({
  messageDetail,
  userId,
}: {
  messageDetail: MessageModel;
  userId: number;
}) {
  const { sentOn, message, fileList: files, sentById } = messageDetail;

  return (
    <>
      <div
        className={`flex flex-1 mb-[20px] ${
          sentById == userId ? "justify-end" : "justify-start"
        }`}
      >
        <div className="min-w-[30%] max-w-[85%]">
          <div
            className={`p-[15px] rounded-[10px] flex-1 ${
              sentById == userId ? "bg-[#dcd7f8]" : "bg-[#e9e9e9]"
            }`}
          >
            <div className="flex-1 flex-grow flex-shrink">{message}</div>
            <ImageList files={files} />
          </div>
          <div className="mt-[7px]">
            <div className="text-[12px] text-[#989898]">{sentOn}</div>
          </div>
        </div>
      </div>
    </>
  );
}

export const MessageList = () => {
  const messages = useSelector((state: RootState) => state.chat.messages);
  const recipientId = useSelector(
    (state: RootState) => state.chat.selectedRecipient?.userId
  );
  const userId = useSelector(
    (state: RootState) => state.login.userDetail.userId
  );
  const [getMessages] = useGetMessagesMutation();
  const [markAsRead] = useMarkMessageAsReadMutation();

  useEffect(() => {
    if (recipientId) {
      getMessages({
        recipientId,
        pageNo: 1,
        pageSize: 10,
      });
    }
  }, [recipientId]);

  useEffect(() => {
    if (messages.some((m) => !m.hasRead)) {
      markAsRead({
        recipientId,
      });
    }
  }, [messages]);

  return (
    <>
      {messages.map((item) => (
        <Message key={item.recipientId} messageDetail={item} userId={userId} />
      ))}
    </>
  );
};
